import { SiteKpiProgress } from "interfaces/kpis";

export const getGroupedByActivityType = (
  kpis: SiteKpiProgress[]
): Record<string, SiteKpiProgress[]> => {
  const groupedByActivityType: Record<string, SiteKpiProgress[]> = {};

  kpis.forEach(kpi => {
    const activityType = kpi.activity_type;
    if (!groupedByActivityType[activityType]) {
      groupedByActivityType[activityType] = [];
    }
    groupedByActivityType[activityType].push(kpi);
  });

  return groupedByActivityType;
};
